<div
	class="bg-white rounded-xl w-full h-full flex flex-col flex-1 items-center justify-center gap-5 text-center px-2"
>
	<img class="max-w-350 w-full -mt-8" src="/assets/images/403.svg" />
	<h3 class="-mt-16">Access to this file has been restricted</h3>
	<p>
		You do not have access to this file as you are not assigned to it.<br />
		Please contact an admin for further details.
	</p>
	<app-button size="small" [icon]="ICON.HOME" btn="primary" (click)="onClick()"
		>Back to dashboard</app-button
	>
</div>
